import { defineComponent as h, openBlock as a, createElementBlock as o, mergeProps as p, unref as e, renderSlot as u, createElementVNode as n, createCommentVNode as i } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, Z = { key: 1 }, f = { key: 2 }, k = { key: 3 }, M = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconSubsetOf"
}, V = /* @__PURE__ */ h({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: H, weight: l } = m(r);
    return (d, t) => (a(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(H)), [
      u(d.$slots, "default"),
      e(l) === "bold" ? (a(), o("g", g, t[0] || (t[0] = [
        n("path", { d: "M212,208a12,12,0,0,1-12,12H48a12,12,0,0,1,0-24H200A12,12,0,0,1,212,208Zm-12-52H104a44,44,0,0,1,0-88h96a12,12,0,0,0,0-24H104a68,68,0,0,0,0,136h96a12,12,0,0,0,0-24Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (a(), o("g", Z, t[1] || (t[1] = [
        n("path", {
          d: "M200,56V168H104a56,56,0,0,1,0-112Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M208,208a8,8,0,0,1-8,8H48a8,8,0,0,1,0-16H200A8,8,0,0,1,208,208Zm-8-48H104a48,48,0,0,1,0-96h96a8,8,0,0,0,0-16H104a64,64,0,0,0,0,128h96a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : e(l) === "fill" ? (a(), o("g", f, t[2] || (t[2] = [
        n("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM176,184H80a8,8,0,0,1,0-16h96a8,8,0,0,1,0,16Zm-64-48h64a8,8,0,0,1,0,16H112a40,40,0,0,1,0-80h64a8,8,0,0,1,0,16H112a24,24,0,0,0,0,48Z" }, null, -1)
      ]))) : e(l) === "light" ? (a(), o("g", k, t[3] || (t[3] = [
        n("path", { d: "M206,208a6,6,0,0,1-6,6H48a6,6,0,0,1,0-12H200A6,6,0,0,1,206,208Zm-6-46H104a50,50,0,0,1,0-100h96a6,6,0,0,0,0-12H104a62,62,0,0,0,0,124h96a6,6,0,0,0,0-12Z" }, null, -1)
      ]))) : e(l) === "regular" ? (a(), o("g", M, t[4] || (t[4] = [
        n("path", { d: "M208,208a8,8,0,0,1-8,8H48a8,8,0,0,1,0-16H200A8,8,0,0,1,208,208Zm-8-48H104a48,48,0,0,1,0-96h96a8,8,0,0,0,0-16H104a64,64,0,0,0,0,128h96a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : e(l) === "thin" ? (a(), o("g", w, t[5] || (t[5] = [
        n("path", { d: "M204,208a4,4,0,0,1-4,4H48a4,4,0,0,1,0-8H200A4,4,0,0,1,204,208Zm-4-44H104a52,52,0,0,1,0-104h96a4,4,0,0,0,0-8H104a60,60,0,0,0,0,120h96a4,4,0,0,0,0-8Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  V as default
};
